import styles from '../style.module.scss';
import { type ContactDetails } from '../types';

export type ContactFieldErrors = Partial<Record<keyof ContactDetails, string>>;

interface ContactFieldsProps {
  values: ContactDetails;
  errors: ContactFieldErrors;
  onChange: (field: keyof ContactDetails, value: string) => void;
}

export function ContactFields({ values, errors, onChange }: ContactFieldsProps) {
  return (
    <div className={styles.contactRow}>
      <div className={styles.field}>
        <label htmlFor="sc-user-name" className={styles.label}>
          User Name
        </label>
        <input
          id="sc-user-name"
          type="text"
          className={styles.input}
          value={values.userName}
          autoComplete="name"
          required
          aria-required="true"
          aria-invalid={errors.userName ? 'true' : undefined}
          aria-describedby={errors.userName ? 'sc-user-name-error' : undefined}
          onChange={(e) => onChange('userName', e.target.value)}
        />
        {errors.userName ? (
          <p id="sc-user-name-error" className={styles.fieldError} role="alert">
            {errors.userName}
          </p>
        ) : null}
      </div>

      <div className={styles.field}>
        <label htmlFor="sc-email" className={styles.label}>
          Email Address
        </label>
        <input
          id="sc-email"
          type="email"
          className={styles.input}
          value={values.email}
          autoComplete="email"
          required
          aria-required="true"
          aria-invalid={errors.email ? 'true' : undefined}
          aria-describedby={errors.email ? 'sc-email-error' : undefined}
          onChange={(e) => onChange('email', e.target.value)}
        />
        {errors.email ? (
          <p id="sc-email-error" className={styles.fieldError} role="alert">
            {errors.email}
          </p>
        ) : null}
      </div>

      <div className={styles.field}>
        <label htmlFor="sc-platform" className={styles.label}>
          Platform Being Scored
        </label>
        <input
          id="sc-platform"
          type="text"
          className={styles.input}
          value={values.platform}
          autoComplete="off"
          required
          aria-required="true"
          aria-invalid={errors.platform ? 'true' : undefined}
          aria-describedby={errors.platform ? 'sc-platform-error' : undefined}
          onChange={(e) => onChange('platform', e.target.value)}
        />
        {errors.platform ? (
          <p id="sc-platform-error" className={styles.fieldError} role="alert">
            {errors.platform}
          </p>
        ) : null}
      </div>
    </div>
  );
}
